'use strict';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {LoadMoreComponent} from '../../../core-components/loading-icon/components/LoadMoreComponent';
import {ViewMode} from '../../../core-utilities/enums/ViewMode';
import {Button} from '../../buttons/Button/index';
import {MeasuredChatView} from '../../lists/MeasuredChatView/index';
import {I18nMessage} from '../../I18nMessage/index';
import {ViewHeader} from '../ViewHeader/index';


export function AppNavigationLayoutView(props) {
  return (
    <div className={classNames("AppNavigationLayout", props.className)}>
      <ViewHeader>
        <span className="AppNavigationLayout__header__title">
          <I18nMessage message="navigation.header.title" />
        </span>
        {props.viewHeaderContent}
      </ViewHeader>

      <div className="AppNavigationLayout__scrollArea">
        <MeasuredChatView
          className="AppNavigationLayout__scroll"
          flipped={false}
          autoScroll={false}
          scrollLoadThreshold={50}
          onInfiniteLoad={props.onLoadMore}
          usePropLoading={true}
          loadingSpinnerDelegate={<LoadMoreComponent mode={props.mode} />}
          isInfiniteLoading={props.mode === ViewMode.LOADING_MORE}
        >
          <div className="AppNavigationLayout__content">
            <div className="AppNavigationLayout__banner">
              <div className="AppNavigationLayout__banner__wrapper">
                <span className="AppNavigationLayout__banner__title">
                  {props.showBack ? (
                    <Button
                      className="IconButton BaseButton AppNavigationLayout__banner__backBtn"
                      iconClass="ion-arrow-left-c"
                      onClick={props.onClickBack}
                    />
                  ) : null}
                  {props.headerLabelContent}
                </span>
                <span className="AppNavigationLayout__banner__description">
                  {props.headerDescriptionContent}
                </span>
              </div>
              <div className="AppNavigationLayout__banner__filter">
                {props.filterComponent}
              </div>
            </div>

            {props.children}
          </div>
        </MeasuredChatView>
      </div>
    </div>
  );
}

AppNavigationLayoutView.propTypes = {
  className: T.string,
  showBack: T.bool,
  onClickBack: T.func,

  headerLabelContent: T.node.isRequired,
  headerDescriptionContent: T.node.isRequired,
  filterComponent: T.node.isRequired,
  children: T.node.isRequired,
  viewHeaderContent: T.oneOfType([T.string, T.node]),
};



// WEBPACK FOOTER //
// ./src/js/components/views/AppNavigationLayout/AppNavigationLayoutView.js